export default __webpack_public_path__ + "images/ups-logo-transparent-4275.png";